import { useQuery } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../../core/hooks';
import { isValidCustomerId } from '../../../../customers';
import { Timespan } from '../../../chart-settings/model';
import { getSlaMonitoredServices } from '../../api';
import { SlaMonitoredServicesHttpQuery } from '../../config';
import { mapSlaMonitoredServiceApiToViewModel, SlaMonitoredClassOfServiceViewModel } from '../../model';

export interface SlaMonitoredServicesApiGetHookResult {
  slaMonitoredClassesOfService: SlaMonitoredClassOfServiceViewModel[] | null;
  isFetching: boolean;
  isFetched: boolean;
}

export const useSlaMonitoredServicesApiGet = (customerId: number | null, timespan: Timespan): SlaMonitoredServicesApiGetHookResult => {
  const axios = useAuthorizedAxios();
  const { data, isFetched, isFetching } = useQuery({
    queryKey: [SlaMonitoredServicesHttpQuery['GetSlaMonitoredServices'].key, timespan, customerId],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        const apiSlaMonitoredServices = await getSlaMonitoredServices(axios, { customerId, timespan });
        return mapSlaMonitoredServiceApiToViewModel(apiSlaMonitoredServices);
      }
    },
    enabled: isValidCustomerId(customerId),
    structuralSharing: false,
    initialData: [],
    gcTime: Infinity,
    staleTime: 0,
  });
  return {
    slaMonitoredClassesOfService: data,
    isFetched,
    isFetching
  }
};